export const error = {
  below4: '4文字以内で入力してください',
  below13Number: '13文字以下の数字を入力してください',
  below15: '15文字以内で入力してください',
  below20: '20文字以内で入力してください',
  below30: '30文字以内で入力してください',
  below50: '50以下の数字を入力してください',
  below50text: '50文字以内で入力してください',
  below100: '100文字以内で入力してください',
  below250: '250文字以内で入力してください',
  fileNameBelow250: 'ファイル名は250文字以内で入力してください',
  below2000: '2000文字以内で入力してください',
  below100000: '99,999以下で入力してください',
  below1000000000000000: '999,999,999,999,999以下で入力してください',
  decimal3: '100以上は整数、99以下は小数第3位までで入力してください',
  decimal1: '小数第1位までで入力してください',
  email: 'メールアドレス形式で入力してください',
  emailMismatch: 'メールアドレスが一致しません',
  excludeLtd: '「株式会社」「(株)」「カ）」は入力できません',
  halfSizeNumber: '半角数字で入力してください',
  imageBelow3: '3件までしか登録できません',
  kana: 'カタカナ、半角数字で入力してください',
  nameKana: 'カタカナで入力してください',
  number: '数字を入力してください',
  abave1: '0以上の数字を入力してください',
  min: '6文字以上を入力してください',
  integer: '整数で入力してください',
  mixed: '英数字を組み合わせて入力してください',
  passwordMatch: 'パスワードが一致しません',
  required: '必須入力です',
  requiredSelect: '必須です',
  requiredCo2: '「算定したCO2排出原単位」か「CO2削減率」のどちらか必須です',
  uniqueEmail: '現在のメールアドレスとは異なるメールアドレスを入力してください',
  url: 'URL形式で入力してください',
  decimal: '小数点以下1桁までで入力してください',
  tel: '数値とハイフンのみ入力可能です',
  image: 'jpgやpngのファイル形式で入力してください',
  document: 'pdf形式のファイルを指定してください',
  date: '日付形式で入力してください',
  imageSize: '10MB以下の画像をアップロードしてください',
  fileSize: '20MB以下のファイルをアップロードしてください',
  csvdocument: 'CSV形式でアップロードしてください',
  csvdecode: 'SJISでエンコーディングしてください',
  specialChar: '特殊文字や制御文字が含まれています',
  terms: '必須です'
};
